import React from "react";
import { Snackbar, Alert } from "@mui/material";

function SnackbarComponent(props) {
    //severity has 4 types
    //success,info,error,warning
    const { open, handleClose, message, severity } = props;
    return (
        <div>
            {" "}
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                // sx={{ height: "25%" }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}>
                <Alert variant="filled" onClose={handleClose} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default SnackbarComponent;